























import { Component, PropSync, Prop } from 'vue-property-decorator'
import { Getter, Action } from "vuex-class";
import BaseFilter from "@/components/Filter/BaseFilter";
import { SelectWings, ToggleWings, FilterWings } from '@/components';
import { TemplatesFilterParams } from "@/store/sms/templates/types";
import FilterSelectedItemWings from "@/components/Filter/FilterSelectedItemWings.vue";
import { notifyError } from "@/utils/notify-helper";
import { MsgTransports } from '@/store/types';


@Component({components: {FilterSelectedItemWings, SelectWings, ToggleWings, FilterWings}})
export default class TemplatesFilter extends BaseFilter<TemplatesFilterParams> {
  @PropSync('show') is_show!: boolean;
  @Prop() transport!: MsgTransports;

  @Getter("templatesStatusList") statusList: any;
  @Getter("priorityList") priorityList: any;

  @Action("getTemplates") actionGetTemplates: any;
  @Action("exportTemplates") actionExportTemplates: any;
  private emailTransport: MsgTransports = MsgTransports.EMAIL;

  defaultFilter(): TemplatesFilterParams {
    return {
      id: undefined,
      partner: undefined,
      partner_user: undefined,
      name: undefined,
      status: undefined,
      priority: undefined,
      message: undefined,
      content: undefined,
      subject: undefined,
    }
  }

  storageItemName(): string {
    return `${this.transport}TemplateFilter`;
  }

  created() {
    this.filtered();
  }

  onFilteredAction(): void {
    this.actionGetTemplates({filter: this.filter, transport: this.transport});
  }

  async export(): Promise<any> {
    try {
      this.actionExportTemplates({filter: this.filter, transport: this.transport})
    } catch(error) {
      notifyError(error);
    }
  };
}
